// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes snow {
  0% {
    opacity: 0;
    transform: translateY(0px);
  }

  20% {
    opacity: 1;
  }

  100% {
    opacity: 1;
    transform: translateY(650px);
  }
}

@keyframes astronaut {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.box-of-star1,
.box-of-star2,
.box-of-star3,
.box-of-star4 {
  width: 100%;
  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
  transform: translateY(0px);
  height: 700px;
}

.box-of-star1 {
  animation: snow 5s linear infinite;
}

.box-of-star2 {
  animation: snow 5s -1.64s linear infinite;
}

.box-of-star3 {
  animation: snow 5s -2.3s linear infinite;
}

.box-of-star4 {
  animation: snow 5s -3.3s linear infinite;
}

.star {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  z-index: 10;
  opacity: 0.7;
}

.star:before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  z-index: 10;
  top: 80px;
  left: 70px;
  opacity: 0.7;
}

.star:after {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  z-index: 10;
  top: 8px;
  left: 170px;
  opacity: 0.9;
}

.star-position1 {
  top: 30px;
  left: 20px;
}

.star-position2 {
  top: 110px;
  left: 250px;
}

.star-position3 {
  top: 60px;
  left: 570px;
}

.star-position4 {
  top: 120px;
  left: 900px;
}

.star-position5 {
  top: 20px;
  left: 1120px;
}

.star-position6 {
  top: 90px;
  left: 1280px;
}

.star-position7 {
  top: 30px;
  left: 1480px;
}

.astronaut {
  width: 250px;
  height: 300px;
  position: absolute;
  z-index: 11;
  top: calc(50% - 150px);
  left: calc(50% - 125px);
  animation: astronaut 5s linear infinite;
}

.schoolbag {
  width: 100px;
  height: 150px;
  position: absolute;
  z-index: 1;
  top: calc(50% - 75px);
  left: calc(50% - 50px);
  background-color: #94b7ca;
  border-radius: 50px 50px 0 0 / 30px 30px 0 0;
}

.head {
  width: 97px;
  height: 80px;
  position: absolute;
  z-index: 3;
  background: -webkit-linear-gradient(
    left,
    #e3e8eb 0%,
    #e3e8eb 50%,
    #fbfdfa 50%,
    #fbfdfa 100%
  );
  border-radius: 50%;
  top: 34px;
  left: calc(50% - 47.5px);
}

.head:after {
  content: "";
  width: 60px;
  height: 50px;
  position: absolute;
  top: calc(50% - 25px);
  left: calc(50% - 30px);
  background: -webkit-linear-gradient(
    top,
    #15aece 0%,
    #15aece 50%,
    #0391bf 50%,
    #0391bf 100%
  );
  border-radius: 15px;
}

.head:before {
  content: "";
  width: 12px;
  height: 25px;
  position: absolute;
  top: calc(50% - 12.5px);
  left: -4px;
  background-color: #618095;
  border-radius: 5px;
  box-shadow: 92px 0px 0px #618095;
}

.body {
  width: 85px;
  height: 100px;
  position: absolute;
  z-index: 2;
  background-color: #fffbff;
  border-radius: 40px / 20px;
  top: 105px;
  left: calc(50% - 41px);
  background: -webkit-linear-gradient(
    left,
    #e3e8eb 0%,
    #e3e8eb 50%,
    #fbfdfa 50%,
    #fbfdfa 100%
  );
}

.panel {
  width: 60px;
  height: 40px;
  position: absolute;
  top: 20px;
  left: calc(50% - 30px);
  background-color: #b7cceb;
}

.panel:before {
  content: "";
  width: 30px;
  height: 5px;
  position: absolute;
  top: 9px;
  left: 7px;
  background-color: #fbfdfa;
  box-shadow: 0px 9px 0px #fbfdfa, 0px 18px 0px #fbfdfa;
}

.panel:after {
  content: "";
  width: 8px;
  height: 8px;
  position: absolute;
  top: 9px;
  right: 7px;
  background-color: #fbfdfa;
  border-radius: 50%;
  box-shadow: 0px 14px 0px 2px #fbfdfa;
}

.arm {
  width: 80px;
  height: 30px;
  position: absolute;
  top: 121px;
  z-index: 2;
}

.arm-left {
  left: 30px;
  background-color: #e3e8eb;
  border-radius: 0 0 0 39px;
}

.arm-right {
  right: 30px;
  background-color: #fbfdfa;
  border-radius: 0 0 39px 0;
}

.arm-left:before,
.arm-right:before {
  content: "";
  width: 30px;
  height: 70px;
  position: absolute;
  top: -40px;
}

.arm-left:before {
  border-radius: 50px 50px 0px 120px / 50px 50px 0 110px;
  left: 0;
  background-color: #e3e8eb;
}

.arm-right:before {
  border-radius: 50px 50px 120px 0 / 50px 50px 110px 0;
  right: 0;
  background-color: #fbfdfa;
}

.arm-left:after,
.arm-right:after {
  content: "";
  width: 30px;
  height: 10px;
  position: absolute;
  top: -24px;
}

.arm-left:after {
  background-color: #6e91a4;
  left: 0;
}

.arm-right:after {
  right: 0;
  background-color: #b6d2e0;
}

.leg {
  width: 30px;
  height: 40px;
  position: absolute;
  z-index: 2;
  bottom: 70px;
}

.leg-left {
  left: 76px;
  background-color: #e3e8eb;
  transform: rotate(20deg);
}

.leg-right {
  right: 73px;
  background-color: #fbfdfa;
  transform: rotate(-20deg);
}

.leg-left:before,
.leg-right:before {
  content: "";
  width: 50px;
  height: 25px;
  position: absolute;
  bottom: -26px;
}

.leg-left:before {
  left: -20px;
  background-color: #e3e8eb;
  border-radius: 30px 0 0 0;
  border-bottom: 10px solid #6d96ac;
}

.leg-right:before {
  right: -20px;
  background-color: #fbfdfa;
  border-radius: 0 30px 0 0;
  border-bottom: 10px solid #b0cfe4;
}
`, "",{"version":3,"sources":["webpack://./src/asset/css/Loader.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,MAAM;EACN,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV;;;;;;GAMC;EACD,kBAAkB;EAClB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB;;;;;;GAMC;EACD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,sBAAsB;EACtB;;;;;;GAMC;AACH;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sDAAsD;EACtD,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;AACnC","sourcesContent":["@keyframes snow {\n  0% {\n    opacity: 0;\n    transform: translateY(0px);\n  }\n\n  20% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(650px);\n  }\n}\n\n@keyframes astronaut {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.box-of-star1,\n.box-of-star2,\n.box-of-star3,\n.box-of-star4 {\n  width: 100%;\n  position: absolute;\n  z-index: 10;\n  left: 0;\n  top: 0;\n  transform: translateY(0px);\n  height: 700px;\n}\n\n.box-of-star1 {\n  animation: snow 5s linear infinite;\n}\n\n.box-of-star2 {\n  animation: snow 5s -1.64s linear infinite;\n}\n\n.box-of-star3 {\n  animation: snow 5s -2.3s linear infinite;\n}\n\n.box-of-star4 {\n  animation: snow 5s -3.3s linear infinite;\n}\n\n.star {\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background-color: #fff;\n  position: absolute;\n  z-index: 10;\n  opacity: 0.7;\n}\n\n.star:before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: #fff;\n  position: absolute;\n  z-index: 10;\n  top: 80px;\n  left: 70px;\n  opacity: 0.7;\n}\n\n.star:after {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #fff;\n  position: absolute;\n  z-index: 10;\n  top: 8px;\n  left: 170px;\n  opacity: 0.9;\n}\n\n.star-position1 {\n  top: 30px;\n  left: 20px;\n}\n\n.star-position2 {\n  top: 110px;\n  left: 250px;\n}\n\n.star-position3 {\n  top: 60px;\n  left: 570px;\n}\n\n.star-position4 {\n  top: 120px;\n  left: 900px;\n}\n\n.star-position5 {\n  top: 20px;\n  left: 1120px;\n}\n\n.star-position6 {\n  top: 90px;\n  left: 1280px;\n}\n\n.star-position7 {\n  top: 30px;\n  left: 1480px;\n}\n\n.astronaut {\n  width: 250px;\n  height: 300px;\n  position: absolute;\n  z-index: 11;\n  top: calc(50% - 150px);\n  left: calc(50% - 125px);\n  animation: astronaut 5s linear infinite;\n}\n\n.schoolbag {\n  width: 100px;\n  height: 150px;\n  position: absolute;\n  z-index: 1;\n  top: calc(50% - 75px);\n  left: calc(50% - 50px);\n  background-color: #94b7ca;\n  border-radius: 50px 50px 0 0 / 30px 30px 0 0;\n}\n\n.head {\n  width: 97px;\n  height: 80px;\n  position: absolute;\n  z-index: 3;\n  background: -webkit-linear-gradient(\n    left,\n    #e3e8eb 0%,\n    #e3e8eb 50%,\n    #fbfdfa 50%,\n    #fbfdfa 100%\n  );\n  border-radius: 50%;\n  top: 34px;\n  left: calc(50% - 47.5px);\n}\n\n.head:after {\n  content: \"\";\n  width: 60px;\n  height: 50px;\n  position: absolute;\n  top: calc(50% - 25px);\n  left: calc(50% - 30px);\n  background: -webkit-linear-gradient(\n    top,\n    #15aece 0%,\n    #15aece 50%,\n    #0391bf 50%,\n    #0391bf 100%\n  );\n  border-radius: 15px;\n}\n\n.head:before {\n  content: \"\";\n  width: 12px;\n  height: 25px;\n  position: absolute;\n  top: calc(50% - 12.5px);\n  left: -4px;\n  background-color: #618095;\n  border-radius: 5px;\n  box-shadow: 92px 0px 0px #618095;\n}\n\n.body {\n  width: 85px;\n  height: 100px;\n  position: absolute;\n  z-index: 2;\n  background-color: #fffbff;\n  border-radius: 40px / 20px;\n  top: 105px;\n  left: calc(50% - 41px);\n  background: -webkit-linear-gradient(\n    left,\n    #e3e8eb 0%,\n    #e3e8eb 50%,\n    #fbfdfa 50%,\n    #fbfdfa 100%\n  );\n}\n\n.panel {\n  width: 60px;\n  height: 40px;\n  position: absolute;\n  top: 20px;\n  left: calc(50% - 30px);\n  background-color: #b7cceb;\n}\n\n.panel:before {\n  content: \"\";\n  width: 30px;\n  height: 5px;\n  position: absolute;\n  top: 9px;\n  left: 7px;\n  background-color: #fbfdfa;\n  box-shadow: 0px 9px 0px #fbfdfa, 0px 18px 0px #fbfdfa;\n}\n\n.panel:after {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  top: 9px;\n  right: 7px;\n  background-color: #fbfdfa;\n  border-radius: 50%;\n  box-shadow: 0px 14px 0px 2px #fbfdfa;\n}\n\n.arm {\n  width: 80px;\n  height: 30px;\n  position: absolute;\n  top: 121px;\n  z-index: 2;\n}\n\n.arm-left {\n  left: 30px;\n  background-color: #e3e8eb;\n  border-radius: 0 0 0 39px;\n}\n\n.arm-right {\n  right: 30px;\n  background-color: #fbfdfa;\n  border-radius: 0 0 39px 0;\n}\n\n.arm-left:before,\n.arm-right:before {\n  content: \"\";\n  width: 30px;\n  height: 70px;\n  position: absolute;\n  top: -40px;\n}\n\n.arm-left:before {\n  border-radius: 50px 50px 0px 120px / 50px 50px 0 110px;\n  left: 0;\n  background-color: #e3e8eb;\n}\n\n.arm-right:before {\n  border-radius: 50px 50px 120px 0 / 50px 50px 110px 0;\n  right: 0;\n  background-color: #fbfdfa;\n}\n\n.arm-left:after,\n.arm-right:after {\n  content: \"\";\n  width: 30px;\n  height: 10px;\n  position: absolute;\n  top: -24px;\n}\n\n.arm-left:after {\n  background-color: #6e91a4;\n  left: 0;\n}\n\n.arm-right:after {\n  right: 0;\n  background-color: #b6d2e0;\n}\n\n.leg {\n  width: 30px;\n  height: 40px;\n  position: absolute;\n  z-index: 2;\n  bottom: 70px;\n}\n\n.leg-left {\n  left: 76px;\n  background-color: #e3e8eb;\n  transform: rotate(20deg);\n}\n\n.leg-right {\n  right: 73px;\n  background-color: #fbfdfa;\n  transform: rotate(-20deg);\n}\n\n.leg-left:before,\n.leg-right:before {\n  content: \"\";\n  width: 50px;\n  height: 25px;\n  position: absolute;\n  bottom: -26px;\n}\n\n.leg-left:before {\n  left: -20px;\n  background-color: #e3e8eb;\n  border-radius: 30px 0 0 0;\n  border-bottom: 10px solid #6d96ac;\n}\n\n.leg-right:before {\n  right: -20px;\n  background-color: #fbfdfa;\n  border-radius: 0 30px 0 0;\n  border-bottom: 10px solid #b0cfe4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
